import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './LanguageDropdown.css';
import icon from './icons/language_24dp.svg';

const LanguageDropdown = () => {
  const { i18n, t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const languages = [
    { code: 'en', name: 'English' },
    { code: 'zh-Hans', name: '简体中文' },
    { code: 'zh-Hant', name: '繁體中文' }
  ];

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="language-dropdown" ref={dropdownRef}>
      
      <div
        className="language-toggle"
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
      >
        <img src={icon} alt={t('common.lang')}/>

      </div>


      {isOpen && (
        <div className="language-menu">
          {languages.map((lang) => (
            <div key={lang.code} className="language-item">
              <button
                onClick={() => changeLanguage(lang.code)}
                className={i18n.language === lang.code ? 'active' : ''}
              >
                {lang.name}
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageDropdown;